module.exports = __webpack_public_path__ + "static/projects_dashboard-50b00006e3b93b631087982faa71c903.png";